import { render, staticRenderFns } from "./IconThunderV52.vue?vue&type=template&id=4904ee5c"
import script from "./IconThunderV52.vue?vue&type=script&lang=js"
export * from "./IconThunderV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports